var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initBlogCard = /* @__PURE__ */ __name(($el, $refs, blogHandle) => {
  var _a, _b;
  const random_id = utils.shortUUID();
  const blog = _blogs[blogHandle] || utils.JSONParse((_a = document.querySelector(`[data-blog-data="${blogHandle}"]`)) == null ? void 0 : _a.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...blog != null ? blog : {},
    url: (_b = blog == null ? void 0 : blog.url) != null ? _b : `/blogs/${blog == null ? void 0 : blog.handle}`
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicText,
    getContentLabels
  };
}, "initBlogCard");
const hydrateBlogCard = /* @__PURE__ */ __name(($el, card_handle, blog_handle, blog_id, classes = []) => {
  const hydrateBlogCardContent = /* @__PURE__ */ __name(() => {
    var _a;
    const node = (_a = document.querySelector(`[data-blog-card='${card_handle}']`)) == null ? void 0 : _a.cloneNode(true);
    if (!node && !$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver((mutation, obs) => {
        var _a2;
        if ($el.hasAttribute("data-cards-loaded")) {
          $el.removeAttribute("data-intersected");
          const node2 = (_a2 = document.querySelector(`[data-blog-card='${card_handle}']`)) == null ? void 0 : _a2.cloneNode(true);
          if (node2 && $el && $el.parentNode) {
            node2 == null ? void 0 : node2.removeAttribute(`data-blog-card`);
            node2 == null ? void 0 : node2.setAttribute("data-blog-handle", blog_handle);
            node2 == null ? void 0 : node2.setAttribute("data-blog-id", blog_id);
            node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
              el.remove();
            });
            node2.classList.add(...classes);
            $el.parentNode.replaceChild(node2, $el);
          }
          mo.disconnect();
          observer.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      return;
    }
    if (node && $el && $el.parentNode) {
      node == null ? void 0 : node.removeAttribute(`data-blog-card`);
      node == null ? void 0 : node.setAttribute("data-blog-handle", blog_handle);
      node == null ? void 0 : node.setAttribute("data-blog-id", blog_id);
      node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
        el.remove();
      });
      node.classList.add(...classes);
      $el.parentNode.replaceChild(node, $el);
    }
  }, "hydrateBlogCardContent");
  if ($el.hasAttribute("data-intersected")) {
    hydrateBlogCardContent();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        hydrateBlogCardContent();
        observer.disconnect();
      }
    },
    { rootMargin: "300px 300px 300px 300px" }
  );
  observer.observe($el);
}, "hydrateBlogCard");
window._sections["initBlogCard"] = initBlogCard;
window._sections["hydrateBlogCard"] = hydrateBlogCard;
